<template>
	<div class="form-group mb-3">
        <b-row>
        <b-col sm="12">
            <label>{{ $t('Document Type') }} <span class="text-danger">*</span></label>
        </b-col>

        <b-col sm="12">
            <select name="doc_type" v-model="doc_type" class="form-control" @change="selectedDocument()" :disabled="status==0 || status==1">
                <option :value="index" v-for="(item,index) in data" :key="item.id">{{$t(item.name)}}</option>
            </select>

            <div v-if="error" class="invalid-feedback d-block mb-3">
                {{error}}
            </div>
        </b-col>
        </b-row>  
    </div>
</template>
<script>

  export default {
    name: 'doc-option',
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        doc_type:0,
        error:''
      }
    },
    props: ['data','category','status'],
    methods:{
        selectedDocument(){
            const data = {"category":this.category,"index":this.doc_type};
            this.$emit('selected-document',data);
        }
    },
    mounted(){

    }
  };
</script>
